import { User } from '../store/Users/UserModels';

/**
 * Creates a string with a `User`s first name and last name
 * @param {User} user - A `User`
 * @return - a string with the Users first name and last name concatenated
 */
export default function toFullName({ firstName = '', lastName = '' }: Partial<User> & object): string {
  return `${firstName.trim()} ${lastName.trim()}`.trim();
};